import React from "react";
import { number, func, string } from "prop-types";
import { WithFacebookLogin } from "@quintype/components";

import Facebook from "../icons/social-share/facebook";

import { getSubscriptionInfo, getPushNotificationStatus } from "../../utils/utils";

const FacebookAuth = ({ facebookId, setMember, setLoading, closePopup, text, setUpUserFlow, initiateCallback }) => {
  const socialLogin = (e, login) => {
    e.preventDefault();
    setLoading(true);
    initiateCallback && initiateCallback();

    window.dataLayer.push({
      event: "login_initiated",
      login_source: "Facebook login",
    });

    login()
      .then(({ member }) => {
        window.dataLayer.push({
          event: "login_completed",
        });
        setMember(member);

        getSubscriptionInfo({
          userid: `${member.id}`,
          login: `Yes - ${member["verification-status"]}`,
          connect_level: getPushNotificationStatus(),
        });
        setLoading(false);
        setUpUserFlow && setUpUserFlow();
        closePopup && closePopup();
      })
      .catch(() => {
        setLoading(false);
        window.dataLayer.push({
          event: "login_failed",
          login_failure_reason: "something went wrong!, please try again later",
        });
      });
  };

  return (
    <WithFacebookLogin appId={facebookId} scope="email" emailMandatory>
      {({ login, serverSideLoginPath }) => (
        <a href={serverSideLoginPath} onClick={(e) => socialLogin(e, login)}>
          <Facebook text={text} />
        </a>
      )}
    </WithFacebookLogin>
  );
};

FacebookAuth.propTypes = {
  facebookId: number,
  text: string.isRequired,
  setMember: func.isRequired,
  setLoading: func.isRequired,
  closePopup: func,
  setUpUserFlow: func,
  initiateCallback: func,
};

export default FacebookAuth;
